var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Footer text",
    d: "M6.88496 11.9759L1.04405 6.13497C0.578143 5.66906 0.267536 5.12739 0.112233 4.50997C-0.0392817 3.89254 -0.0373878 3.2789 0.117915 2.66906C0.273218 2.05542 0.581931 1.52133 1.04405 1.06678C1.51754 0.600874 2.05731 0.292162 2.66337 0.140647C3.27322 -0.0146559 3.88117 -0.0146559 4.48723 0.140647C5.09708 0.29595 5.63875 0.604662 6.11223 1.06678L6.88496 1.81678L7.65769 1.06678C8.13496 0.604662 8.67663 0.29595 9.28269 0.140647C9.88875 -0.0146559 10.4948 -0.0146559 11.1009 0.140647C11.7107 0.292162 12.2524 0.600874 12.7259 1.06678C13.188 1.52133 13.4967 2.05542 13.652 2.66906C13.8073 3.2789 13.8073 3.89254 13.652 4.50997C13.5005 5.12739 13.1918 5.66906 12.7259 6.13497L6.88496 11.9759Z",
    fill: "#FAFAFA",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.0e8c6d4473b26ac946df8c533d44dc85.svg";
export { ForwardRef as ReactComponent };